import React from "react";
import PageHeader from "@/components/layout/PageHeader";
import { ExternalLink } from "lucide-react";
import { SPONSORS } from "@/lib/sponsors";

// Add or edit links here. Each link opens in a new tab.
// Example: { label: "Schoology Login", url: "https://schoology.com" }
const LINKS = [
  {
    label: "2025 Alabama Course of Study: Digital Literacy and Computer Science",
    url: "https://www.alabamaachieves.org/wp-content/uploads/2026/05/AS_2026511_DigLitCS_v1.pdf",
  },
  {
    label: "Alabama Learning Exchange (ALEX)",
    url: "https://alabamalearningexchange.org/home",
  },
  {
    label: "Alabama Virtual Library",
    url: "https://www.avl.lib.al.us/",
  },
  {
    label: "AMSTI Summer Learning",
    url: "https://www.canva.com/design/DAHGY8G4Xws/-7-h2EqGRs-RKsv2mTrj_g/view?utm_content=DAHGY8G4Xws&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=hcd84c188b4",
  },
  {
    label: "Birmingham City Schools",
    url: "https://www.bhm.k12.al.us/",
  },
  {
    label: "EdFarm",
    url: "https://www.edfarm.org/",
  },
  {
    label: "International Society for Technology and Education",
    url: "https://iste.org/",
  },
  {
    label: "PowerSchool PD",
    url: "https://alsde.truenorthlogic.com/ia/empari/login/index",
  },
  {
    label: "Schoology",
    url: "https://bhm.schoology.com",
  },
  {
    label: "UAB Regional Inservice Center Region 5 Summer Professional Development",
    url: "https://simplebooklet.com/region5summerlearning2026p#page=1",
  },
];

export default function Resources() {
  return (
    <div className="space-y-6 pb-12" data-testid="resources-page">
      <PageHeader title="Resources" barColor="#145261" />

      <div className="bg-card rounded-xl border border-border p-4">
        <h2 className="font-semibold text-sm text-foreground mb-3">Links</h2>
        {LINKS.length > 0 ? (
          <div className="space-y-2">
            {[...LINKS]
              .sort((a, b) =>
                a.label.localeCompare(b.label, undefined, { sensitivity: "base" })
              )
              .map((link) => (
                <p key={link.url}>
                  <a
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1.5 text-primary underline hover:opacity-80 font-medium text-sm"
                    data-testid="resource-link"
                  >
                    {link.label}
                    <ExternalLink className="w-3.5 h-3.5 flex-shrink-0" />
                  </a>
                </p>
              ))}
          </div>
        ) : (
          <p className="text-xs text-muted-foreground">
            Links coming soon.
          </p>
        )}
      </div>

      <div
        id="sponsors"
        className="bg-card rounded-xl border border-border p-4"
      >
        <h2 className="font-semibold text-sm text-foreground mb-4">Sponsors</h2>
        {SPONSORS.length > 0 ? (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
            {SPONSORS.map((s) => {
              const logo = (
                <div className="bg-muted/40 rounded-lg p-4 flex items-center justify-center h-28 overflow-hidden">
                  <img
                    src={s.logo}
                    alt={s.name}
                    style={s.scale ? { transform: `scale(${s.scale})` } : undefined}
                    className="max-h-20 max-w-full object-contain"
                  />
                </div>
              );
              return (
                <div
                  key={s.name}
                  className="flex flex-col items-center gap-2"
                  data-testid="sponsor-card"
                >
                  {s.url ? (
                    <a
                      href={s.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block w-full hover:opacity-80 transition-opacity"
                    >
                      {logo}
                    </a>
                  ) : (
                    logo
                  )}
                  <p className="text-xs text-center font-medium text-foreground">
                    {s.name}
                  </p>
                </div>
              );
            })}
          </div>
        ) : (
          <p className="text-xs text-muted-foreground">
            Sponsor information coming soon.
          </p>
        )}
      </div>
    </div>
  );
}
